/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import {useState} from 'react'
import style from './customizeSectionsSmall.module.css'
import ChangeBackgroundButton from './changeBackgroundButton'
import utils from './utils';
import consts from './consts'
import SaveButton from './saveButton'

import { useStateValue } from '../state';

export default function CustomizeSectionsSmall({onSave, onSkip, hideSkip, hideOptionalFields, hideTitles,
  containerStyle, contentStyle, inputStyle, inputContainerStyle, ChangeBackgroundButtonStyle, buttonStyle, buttonText, onButtonClick})  {
  const MAX_TEXT_AREA_ROWS = 2;
  const defaultCoverImage = '/images/nycPreDefinedCoverPhoto.jpg'
  const defaultTitle = consts.SITE_TEMPLATE_DEFAULTS.TITLE;
  const defaultDescription = consts.SITE_TEMPLATE_DEFAULTS.DESCRIPTION;
  const defaultOneLiner = consts.SITE_TEMPLATE_DEFAULTS.TAGLINE;
  
  const [
    {siteTemplate},
    dispatch,
  ] = useStateValue();

  const [companyName, updateCompanyName] = useState(siteTemplate.title != defaultTitle ? siteTemplate.title : "");
  const [companyDescription, updateCompanyDescription] = useState(siteTemplate.description != defaultDescription ? siteTemplate.description : "");
  const [companyOneLiner, updateCompanyOneLiner] = useState(siteTemplate.oneLiner != defaultOneLiner ? siteTemplate.oneLiner : "");

  function onSaveButtonClick() {
    dispatch({ type: 'SITE-TEMPLATE-CHANGED', payload: {...siteTemplate, coverImage: defaultCoverImage} });
    onSave && onSave({missingInfo: !(companyName != "" && companyDescription != "" && companyOneLiner != "")});
  }

  function renderCustomizationPanel() {
    return (
      <div style={containerStyle} className={style.container}>
        <div style={contentStyle} className={style.innerContainer}>
        <div style={inputContainerStyle} className={style.leftBlock}>
        {!hideTitles && <span className={style.sectionTile}>Your Page title</span>}
         <input style={inputStyle} maxLength={15} value = {companyName}
            onChange={e =>
              {
               dispatch({ type: 'SITE-TEMPLATE-CHANGED', payload: {...siteTemplate, title: e.target.value} });
               updateCompanyName(e.target.value);
            }
          }
            className={style.companyInput} placeholder='E.g. your company/service name'/>
       {!hideOptionalFields && <React.Fragment>
        <input style={inputStyle} maxLength={54} value = {companyOneLiner} 
        onChange={e =>
          {
          dispatch({ type: 'SITE-TEMPLATE-CHANGED', payload: {...siteTemplate, oneLiner: e.target.value} });
          updateCompanyOneLiner(e.target.value);
          }
        }
        className={style.companyInput} placeholder='Your page tagline'/>
        <textarea style={inputStyle} value = {companyDescription}
         onChange={e => 
          {
            let trimdRows = e.target.value.split('\n').map(i => i.substring(0,64));
            let rowCount = e.target.value.split('\n').length;
            if(rowCount <= MAX_TEXT_AREA_ROWS) {
              dispatch({ type: 'SITE-TEMPLATE-CHANGED', payload: {...siteTemplate, description: trimdRows.join('\n').replace(/(?:\r\n|\r|\n)/g, '<br>')} })
              updateCompanyDescription(e.target.value);
            }
          }
        }
        className={style.companyTextarea} placeholder='A short description of your page'/>
       </React.Fragment> }
        {!hideTitles && <span className={style.sectionTile}>Your Page Color</span>}
        <ChangeBackgroundButton colorsBlackList={['#181C45']} ChangeBackgroundButtonStyle={ChangeBackgroundButtonStyle}/>
        </div>
        </div>
        <div className={style.footerContainer}>
        {<button style={buttonStyle} disabled={!(companyName != '')} onClick={onButtonClick ? () => onButtonClick() : () => onSaveButtonClick()} className={companyName != '' ? style.saveButtonEnabled : style.saveButtonDisabled}>{buttonText ||'Continue'}</button>}
        {!hideSkip && <span onClick={onSkip} className={style.later}>I'll add it later</span>}
        </div>
      </div>
    );
  }

     return (
      renderCustomizationPanel() 
    );

};